import { render, staticRenderFns } from "./innovationAwardsPC.vue?vue&type=template&id=285fe49c&scoped=true"
import script from "./innovationAwardsPC.vue?vue&type=script&lang=js"
export * from "./innovationAwardsPC.vue?vue&type=script&lang=js"
import style0 from "./innovationAwardsPC.vue?vue&type=style&index=0&id=285fe49c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285fe49c",
  null
  
)

export default component.exports